// extracted by mini-css-extract-plugin
export default {"buttons":"uOanEmw9","counterparty":"PiJKrT7h","error":"AZu1mT2S"};